async function triggerProgressBar() {
  try {
    const progressBarContainers = document.querySelectorAll('.progress-bar-container')
    const response = await fetch(window.Shopify.routes.root + "?sections=progress-bar")
    const data = await response.json()
    
    const parser = new DOMParser()
    const doc = parser.parseFromString(data["progress-bar"], 'text/html')
    const newProgressBarContainer = doc.querySelector('.progress-bar-container')
    
    progressBarContainers?.forEach(element => element.innerHTML = newProgressBarContainer.innerHTML)

    if (progressBarContainers.length > 0) {
      const progressBar = progressBarContainers[0].querySelector('.progress-bar')
      const freeGiftEnabled = progressBar.getAttribute('product-free-gift-enabled')
      const freeGiftId = progressBar.getAttribute('product-free-gift-id')
      const freeGiftIsAdded = progressBar.getAttribute('product-free-gift-is-added')
      const freeGiftAvailable = progressBar.getAttribute('product-free-gift-available')
      const freeGiftThresholdCompleted = progressBar.getAttribute('product-free-gift-threshold-completed')

      if (!freeGiftId || freeGiftEnabled === 'false' || (freeGiftThresholdCompleted === 'true' && freeGiftIsAdded === 'true')) return

      if (freeGiftThresholdCompleted === 'true' && freeGiftAvailable === 'true') {
        await addFreeGiftItem(freeGiftId)
      } else {
        await removeFreeGiftItem(freeGiftId)
      }
    }
  } catch (error) {
    console.error('Error fetching progress bar:', error)
  }
}

async function addFreeGiftItem(productId, quantity = 1) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [productId]: quantity,
        },
      }),
    })

    if (!response.ok) {
      throw new Error('Error adding free gift to cart')
    }
    console.log('Free gift added to cart')
  } catch (error) {
    console.error('Error:', error)
  } finally {
    await updateShippingBarAfterFreeGiftItem()
  }
}

async function removeFreeGiftItem(productId) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [productId]: 0,
        },
      }),
    })

    if (!response.ok) {
      throw new Error('Error removing free gift from cart')
    }
    console.log('Free gift removed from cart')
  } catch (error) {
    console.error('Error:', error)
  } finally {
    await updateShippingBarAfterFreeGiftItem()
  }
}

async function updateShippingBarAfterFreeGiftItem() {
  try {
    const progressBarContainers = document.querySelectorAll('.progress-bar-container')
    const response = await fetch(window.Shopify.routes.root + "?sections=progress-bar")
    const data = await response.json()
    
    const parser = new DOMParser()
    const doc = parser.parseFromString(data["progress-bar"], 'text/html')
    const newProgressBarContainer = doc.querySelector('.progress-bar-container')
    
    progressBarContainers?.forEach(element => element.innerHTML = newProgressBarContainer.innerHTML)
  } catch (error) {
    console.error('Error updating shipping bar:', error)
  }
}

document.addEventListener('rebuy:cart.ready', triggerProgressBar)
document.addEventListener('rebuy:cart.add', triggerProgressBar)
document.addEventListener('rebuy:smartcart.show', triggerProgressBar)
document.addEventListener('rebuy:smartcart.line-item-increase', triggerProgressBar)
document.addEventListener('rebuy:smartcart.line-item-decrease', triggerProgressBar)
document.addEventListener('rebuy:smartcart.line-item-removed', triggerProgressBar)